module.exports = __webpack_public_path__ + "img/cny.b30a9880.svg";